import main from './scss/main.scss';
import AOS from 'aos';
import Mmenu from 'mmenu-js'

window.addEventListener('DOMContentLoaded', (event) => {
  AOS.init();
});
document.addEventListener(
  "DOMContentLoaded", () => {
    new Mmenu("#menu", {
      // options
    });
  }
);